import { debounce } from 'lodash';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSystem, updateProps } from '../../../contextRedux/SystemType/SystemTypeModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { SystemTypeColumn } from './SystemTypeColumn';

const SystemTypeTable: React.FC<any> = () => {
  const dispatch = useDispatch();
  const reduxSystemType = useSelector((state: RootState) => state.models?.systemType);
  const systemTypes = useSelector((state: RootState) => state.store?.systemType.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxSystemType.props.skip / reduxSystemType.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setSystem(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxSystemType.props.take,
    total: reduxSystemType.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxSystemType.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />

      <CustomTable
        initialDataSource={systemTypes ?? []}
        pagination={paginationConfig}
        columns={SystemTypeColumn(handleEdit)}
        rowKey='id'
      />
    </>
  );
};

export default SystemTypeTable;
